import {ProjectWithPreview} from "../ProjectWithPreview";
import {Box, Typography, Stack, Link} from "@mui/material";
import {CustomChip} from "../CustomChip";
import {BackButton} from "../BackButton";

const CityPinner = () => (
    <ProjectWithPreview projectUrl={"https://www.city-pinner.com/"}>
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            padding: 3,
            height: '100%',
            justifyContent: 'space-between'
        }}>
            <Box sx={{gap: 3, display: 'flex', flexDirection: 'column'}}>
                {/* Project Title */}
                <Box>
                    <Typography variant="h3" sx={{fontWeight: 600, mb: 1}}>
                        CityPinner
                    </Typography>
                    <Typography variant="h6" sx={{color: 'text.secondary'}}>
                        Interactive map-based guessing game with challenge creation system
                    </Typography>
                </Box>

                {/* Overview */}
                <Box>
                    <Typography variant="h5" sx={{color: 'secondary.main', mb: 1, fontWeight: 500}}>
                        Overview
                    </Typography>
                    <Typography variant="body1" sx={{lineHeight: 1.7, whiteSpace: 'pre-line'}}>
                        This project consists of a static Angular website, a Ktor server and a python script
                        for generating cities boundaries.{'\n'}
                        Inspired by <Link href='https://www.geoguessr.com/' target='_blank'>GeoGuessr</Link>
                        , I came up with the idea of a location guessing game focused on specific
                        cities. A friend helped me initiate the beta code foundation, then I independently expanded
                        functionalities, added the backend, deployed it. {'\n'}
                        Because the Maps API is generates costs per usage, I currently keep this game available in a
                        closed circle, but I will gladly provide you access if you want to try it. Create an account,
                        verify it (it it's not created using Google), and I will upgrade you account to premium so
                        you can access the game.
                    </Typography>
                </Box>

                {/* Tech summary */}
                <Box>
                    <Typography variant="h5" sx={{color: 'secondary.main', mb: 1.5, fontWeight: 500}}>
                        Technologies
                    </Typography>
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        <CustomChip text={'Angular'} variant={'primary'}/>
                        <CustomChip text={'Ktor'} variant={'primary'}/>
                        <CustomChip text={'Python'} variant={'primary'}/>
                    </Stack>
                </Box>

                {/* Tools summary */}
                <Box>
                    <Typography variant="h5" sx={{color: 'secondary.main', mb: 1.5, fontWeight: 500}}>
                        Tools
                    </Typography>
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        <CustomChip text={'MongoDB'} variant={'secondary'}/>
                        <CustomChip text={'Postman'} variant={'secondary'}/>
                        <CustomChip text={'Github'} variant={'secondary'}/>
                        <CustomChip text={'Trello'} variant={'secondary'}/>
                        <CustomChip text={'Render.com'} variant={'secondary'}/>
                        <CustomChip text={'Namecheap.com'} variant={'secondary'}/>
                        <CustomChip text={'Zoho Mail'} variant={'secondary'}/>
                        <CustomChip text={'Adobe Photoshop'} variant={'secondary'}/>
                    </Stack>
                </Box>

                {/* Apis summary */}
                <Box>
                    <Typography variant="h5" sx={{color: 'secondary.main', mb: 1.5, fontWeight: 500}}>
                        APIs
                    </Typography>
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        <CustomChip text={'Maps JavaScript API'} variant={'primary'}/>
                        <CustomChip text={'Google OAuth'} variant={'primary'}/>
                    </Stack>
                </Box>
            </Box>

            <Box>
                <BackButton/>
            </Box>
        </Box>
    </ProjectWithPreview>
)

export default CityPinner;